import { Component, Input } from '@angular/core';
import { DLEntry } from '../../../shared/models/description-list-entry.model';

@Component({
    selector: 'app-profile-modal-entries',
    templateUrl: './profile-modal-entries.component.html',
    styleUrls: ['./profile-modal-entries.component.scss'],
    standalone: false
})
export class ProfileModalEntriesComponent {
  @Input() entries: DLEntry[];
  @Input() type: 'income' | 'residence';

  constructor() {}
}
